import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import FetchingFallback from "components/StatusHandler/components/FetchingFallback";

interface ChartLoadingFallbackProps {
  children: React.ReactNode;
}

/** The shared fetching fallback, sized to fill the chart area rather than the viewport. */
function ChartLoadingFallback(props: ChartLoadingFallbackProps) {
  return (
    <ThemeProvider2024>
      <FetchingFallback bgColor="transparent" slotProps={{ root: { sx: { height: "100%" } } }}>
        {props.children}
      </FetchingFallback>
    </ThemeProvider2024>
  );
}

export default ChartLoadingFallback;
